/**
 * A facility's internal number: the customer's own name for it (a branch or cost-centre number,
 * "Niederlassungsnummer"), which a major customer's collective bill prints in its list of
 * facilities. The company account sets it in the portal; both apps check it with these rules.
 */
/** The longest internal number a facility keeps (the column is VARCHAR(30)). */
export const INTERNAL_NUMBER_MAX_LENGTH = 30;
// Letters (umlauts and ß included), digits, spaces and the separators branch numbers use. All of
// them are in the font the bill is printed with.
const INTERNAL_NUMBER_REGEX = /^[0-9A-Za-zÄÖÜäöüß .,\-/_#+:()&]+$/;
/** User-facing explanation of the rule (German, like the rest of the domain). */
export const INTERNAL_NUMBER_HINT = `Höchstens ${INTERNAL_NUMBER_MAX_LENGTH} Zeichen: Buchstaben, Ziffern, Leerzeichen und . , - / _ # + : ( ) &`;
/**
 * The internal number as it is stored: trimmed, inner runs of whitespace as one space.
 *
 * @param value - raw value from a form or an API payload
 * @returns the stored form, or `null` when nothing is left (no internal number)
 */
export const normalizeInternalNumber = (value) => {
    if (typeof value !== "string")
        return null;
    const normalized = value.trim().replace(/\s+/g, " ");
    return normalized.length > 0 ? normalized : null;
};
/**
 * True when `value` may be stored as an internal number once normalized. An empty value is
 * valid: it removes the number.
 *
 * @param value - raw or normalized internal number
 */
export const isValidInternalNumber = (value) => {
    if (value === null || value === undefined)
        return true;
    if (typeof value !== "string")
        return false;
    const normalized = normalizeInternalNumber(value);
    return (normalized === null ||
        (normalized.length <= INTERNAL_NUMBER_MAX_LENGTH && INTERNAL_NUMBER_REGEX.test(normalized)));
};
